import React, { Component, Fragment } from 'react';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

// Demo styles, see 'Styles' section below for some notes on use.
import 'react-accessible-accordion/dist/fancy-example.css';

import './Questions.module.scss';

import PageTitle from '../../components/UI/PageTitle/PageTitle'

import SideNavigation from 'components/UI/SideNavigation/SideNavigation';
import TopNavigation from 'components/UI/TopNavigation/TopNavigation';
import PageWrapper from 'components/UI/PageWrapper/PageWrapper';
import BackgroundPolygons from 'components/UI/BackgroundPolygons/BackgroundPolygons';

class Questions extends Component {

    //scroll to top
    componentDidUpdate() {
      window.scrollTo(0,0);
  }

  componentDidMount() {
      window.scrollTo(0,0);
  }

    render() {

      const questionContent = [{
        question: 'Is de GoTo plug and play?',
        answer: "Voor Windows is het eenmalig nodig om software te installeren om met GoTo te kunnen werken. Daarna zijn deGoTo's zijn volledig plug-and-play. Op Mac en op Linux wordt de GoTo automatisch herkent en kun je meteen aan de slag! Bij de downloads pagina zijn deze downloads te vinden"
    },
    {
        question: 'De GoTo word niet herkend door mijn systeem. Ik zie niet dat de GoTo aangesloten is.',
        answer: '1. Start Snap4Arduino op en kijk of je een connectie kan maken met GoTo. Het kan zijn dat het systeem de GoTo niet als een USB apparaat ziet maar wel een connectie         kan maken met de GoTo. <br> <br> 2. Is dit niet het geval kijk dan of je geen stappen hebt overgeslagen die beschreven zijn in de handleiding. Heb je de drivers correct geïnstalleerd? Mocht je nog steeds problemen ondervinden neem dan contact met ons op.'
    },
    {
      question: "De GoTo kan wel over de X-as bewegen maar niet over de Y-as hoe komt dit?",
      answer: "Kijk of de arm van GoTo niet te ver naar voren staat. Achter op de arm van GoTo zit een vierkant gat. Wanneer deze over het zwarte vierkantje op de plaat van GoTo valt zal de arm stoppen. Dit ter beveiliging dat de arm niet verder gaat. Houd hier ook rekening bij je GoTo projecten."
    },
    {
      question: "Mijn GoTo tikt bij het tekenen hoe kan dit?",
      answer: "Kijk of je de pen niet te strak op het papier hebt gezet. Wanneer dit het geval is kunnen de motoren in de GoTo dit niet altijd aan. Zorg dat de pen net het papier raakt en draai de borgmoer vervolgens losjes vast."
    },
    {
      question: "Mijn GoTo kan geen connectie maken met Snap4Arduino en wordt niet herkent.",
      answer: "Windows <br><br>1. Kijk of je Arduino en de bijbehorende drivers hebt geïnstalleerd. <br>2. Het kan zijn dat je drivers niet up-to-date zijn. Om deze te updaten gebruik de Windows + X en klik op Apparaatbeheer (device manager). <br>3. Klik met je rechtermuisknop op het bovenste icoon in de lijst en selecteer zoeken naar gewijzigde apparaten. <br>4. Wanneer u dit heeft gedaan gaat u naar Universal Serial Bus-controllers (USB)  en klik hierop met uw rechtermuisknop. Selecteer vervolgens weer zoeken naar gewijzigde apparaten. Kijk of de GoTo nu een connectie kan maken in Snap4Arduino. <br><br>MacOS<br>1. Kijk of je Arduino en de bijbehorende drivers hebt geïnstalleerd. <br>2. Wanneer dit het geval is probeer een andere USB-poort indien aanwezig en probeer dan connectie te maken via Snap4Arduino<br>3. Wanneer dit niet het probleem oplost neem dan contact met ons op. Stuur een screenshot mee van je systeem report van je mac. <br>Dit kun je doen door naar Go to Apple -> About This Mac -> More Info... -> System Report te gaan. Stuur het screenshot inclusief de vraag naar goto@studiotast.com."
    },
    {
      question: "In Snap4Arduino kan ik de blokjes met stappen niet terugvinden die in de handleiding beschreven staan.",
      answer: "1. Download opnieuw de installatiebestanden. <br><br>2. In de zip zit nu een geüpdatet versie van de goto-blokken. Wanneer je de blokken opnieuw in laad zul je zien dat het probleem verholpen is."
    },
    {
      question: "Moet ik elke keer de GoTo-blokken importeren in Snap4Arduino?",
      answer: "1. Maak een nieuw project aan in Snap4Arduino <br>2. Importeer hierin de goto-blokken. <br>3. Sla dit project vervolgens op als: Nieuw GoTo project. <br>4. Elke keer wanneer je aan de slag gaat open je dit project. Vervolgens kun je deze opslaan als een ander bestand."
    },
    {
      question: "Mijn GoTo doet schuine lijnen fout.",
      answer: "Meestal helpt het om alleen snap4arduino open te hebben staan, omdat Snap4Arduino dan niet de capaciteit van je computer hoeft te delen."
    },
  ];

        return (
            <Fragment>
                <TopNavigation/>
                <SideNavigation/>
                <PageWrapper>
                <div styleName='main'>
                  <BackgroundPolygons></BackgroundPolygons>
                    <div styleName='maxwidth'>
                      <PageTitle title='Vragen' subtitle='Veelgestelde vragen'/>
                      <Accordion allowZeroExpanded='true'>
                      { questionContent.map((question, index) =>
                          <AccordionItem styleName='accordion_item' key={index}>
                              <div styleName='triangle'></div>
                              <AccordionItemHeading styleName='accordionheading'>
                                <AccordionItemButton styleName='accordion-item-button'>
                                <h3>{question.question}</h3>
                                </AccordionItemButton>
                              </AccordionItemHeading>
                              <AccordionItemPanel>
                                <div styleName='arcordion-content' dangerouslySetInnerHTML={{__html:question.answer}} />
                              </AccordionItemPanel>
                          </AccordionItem>
                      )}
                    </Accordion>
                  </div>
                </div>
                </PageWrapper>
            </Fragment>
        );
    }
}


export default Questions;


// WEBPACK FOOTER //
// ./resources/assets/screens/Questions/Questions.jsx